import _Tab from './Tab';
import _TabList from './TabList';
import _TabPanel from './TabPanel';
import _Tabs from './Tabs';
export default _Tabs;
export var Tab = _Tab;
export var TabList = _TabList;
export var TabPanel = _TabPanel;
export var Tabs = _Tabs;